// Central config for knowledge ingestion
export const ALLOWED_EXTENSIONS = [
  'pdf', 'docx', 'pptx', 'xlsx', 'csv', 'txt', 'md', 'html', 'htm',
  'json', 'xml', 'png', 'jpg', 'jpeg', 'zip',
  // Allow Windows Registry exports to be uploaded as text knowledge
  'reg'
];

export const UI_MAX_FILE_BYTES = (() => {
  const raw = (process.env.NEXT_PUBLIC_UI_MAX_FILE_MB || '').trim();
  const mb = Number(raw);
  const fallback = 200; // 200 MB default for UI uploads
  const limitMb = Number.isFinite(mb) && mb > 0 ? mb : fallback;
  return limitMb * 1024 * 1024;
})();

export const API_MAX_FILE_BYTES = (() => {
  const raw = (process.env.API_MAX_FILE_MB || '').trim();
  const mb = Number(raw);
  const fallback = 1024; // 1 GB default for API/background
  const limitMb = Number.isFinite(mb) && mb > 0 ? mb : fallback;
  return limitMb * 1024 * 1024;
})();

export type RefreshMode = 'schedule' | 'event' | 'manual' | 'on_upload';

export function normalizeExt(name: string): string {
  const m = String(name || '').toLowerCase().match(/\.([a-z0-9]+)$/);
  return m ? m[1] : '';
}
